const modifySubmissionCommunity = function ({ commit, dispatch }, { value }) {
  commit("UPDATE_SUBMISSION_COMMUNITY", { value });
  dispatch("validateSubmission");
};

export default modifySubmissionCommunity;
